var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShortLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.873,
    height: 89.845,
    viewBox: "0 0 89.873 89.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.962,208.446a4.952,4.952,0,0,1,.08-9.9,4.952,4.952,0,1,1-.08,9.9",
    transform: "translate(-81.845 -123.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.546,203.38a4.954,4.954,0,0,1-4.933,4.99,4.966,4.966,0,0,1-.047-9.93,4.938,4.938,0,0,1,4.98,4.94",
    transform: "translate(-50.985 -123.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,44.084a4.936,4.936,0,0,1-9.87.149,4.936,4.936,0,1,1,9.87-.149",
    transform: "translate(-108.596 -24.453)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.664,183.819a4.91,4.91,0,0,1-4.861-5.048,4.929,4.929,0,0,1,9.856.15,4.881,4.881,0,0,1-5,4.9",
    transform: "translate(-108.48 -108.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1,178.487a4.853,4.853,0,0,1,5.19-4.676,4.922,4.922,0,0,1-.478,9.833,4.852,4.852,0,0,1-4.713-5.157",
    transform: "translate(-24.403 -108.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,136.167a4.969,4.969,0,1,1-5.083-4.849,5.009,5.009,0,0,1,5.083,4.849",
    transform: "translate(-123.874 -81.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.182,19.5a4.93,4.93,0,1,1-4.885-5.011,4.905,4.905,0,0,1,4.885,5.011",
    transform: "translate(-81.965 -9.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,39.062a4.917,4.917,0,0,1-.125,9.834,4.917,4.917,0,1,1,.125-9.834",
    transform: "translate(-24.509 -24.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.508,86.9a4.989,4.989,0,0,1-5.034,4.864,4.927,4.927,0,0,1-4.863-5.022,4.95,4.95,0,1,1,9.9.158",
    transform: "translate(-123.964 -51.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.962,14.426a4.931,4.931,0,0,1,4.868,5.041,4.954,4.954,0,0,1-9.906-.175,4.921,4.921,0,0,1,5.038-4.866",
    transform: "translate(-51.134 -9.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4,131.066a4.915,4.915,0,0,1,4.905,5.009,4.952,4.952,0,1,1-9.9-.269,4.913,4.913,0,0,1,5-4.739",
    transform: "translate(-8.99 -81.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.363,91.526a4.893,4.893,0,0,1-4.874-5.017,4.943,4.943,0,1,1,4.874,5.017",
    transform: "translate(-9.043 -50.976)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.073,206.624a4.2,4.2,0,0,1-4.327,4.047,4.191,4.191,0,1,1,4.327-4.047",
    transform: "translate(-101.569 -126.261)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.789,51.15a4.182,4.182,0,1,1,4.159-4.235,4.142,4.142,0,0,1-4.159,4.235",
    transform: "translate(-44.084 -26.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,74.7a4.185,4.185,0,0,1-8.37-.008,4.185,4.185,0,0,1,8.37.008",
    transform: "translate(-108.622 -44.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.687,178.158a4.165,4.165,0,0,1-8.329.082,4.21,4.21,0,0,1,4.133-4.282,4.153,4.153,0,0,1,4.2,4.2",
    transform: "translate(-91.35 -108.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.749,173.985a4.188,4.188,0,1,1-4.139,4.254,4.155,4.155,0,0,1,4.139-4.254",
    transform: "translate(-44.072 -108.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.566,206.577a4.17,4.17,0,1,1-4.128-4.264,4.145,4.145,0,0,1,4.128,4.264",
    transform: "translate(-33.846 -126.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.982,70.6a4.127,4.127,0,0,1,4.2,4.174,4.185,4.185,0,0,1-8.369.043A4.128,4.128,0,0,1,46.982,70.6",
    transform: "translate(-26.724 -44.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,150.435a4.19,4.19,0,1,1-4.24-4.112,4.133,4.133,0,0,1,4.24,4.112",
    transform: "translate(-108.616 -91.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.509,112.589a4.137,4.137,0,0,1-4.186,4.2,4.17,4.17,0,0,1-.043-8.341,4.1,4.1,0,0,1,4.229,4.141",
    transform: "translate(-114.937 -67.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.973,154.62a4.165,4.165,0,0,1,0-8.329,4.165,4.165,0,1,1,0,8.329",
    transform: "translate(-26.734 -91.309)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.269,112.627a4.172,4.172,0,1,1-4.17-4.221,4.17,4.17,0,0,1,4.17,4.221",
    transform: "translate(-135.396 -67.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.921,116.762a4.166,4.166,0,0,1-.129-8.329,4.166,4.166,0,1,1,.129,8.329",
    transform: "translate(-20.436 -67.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.4,166.77a4.177,4.177,0,0,1,8.353.067,4.242,4.242,0,0,1-4.219,4.2,4.177,4.177,0,0,1-4.135-4.266",
    transform: "translate(-126.332 -101.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.551,62.482a4.11,4.11,0,0,1-4.134-4.241,4.172,4.172,0,1,1,4.134,4.241",
    transform: "translate(-126.34 -33.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.347,47.013a4.168,4.168,0,1,1,4.221,4.148,4.155,4.155,0,0,1-4.221-4.148",
    transform: "translate(-91.343 -26.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.9,22.811a4.183,4.183,0,1,1,.064-8.366,4.183,4.183,0,0,1-.064,8.366",
    transform: "translate(-101.571 -9.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.616,216.908a4.161,4.161,0,1,1-4.153,4.222,4.1,4.1,0,0,1,4.153-4.222",
    transform: "translate(-67.698 -135.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.828,166.824a4.138,4.138,0,0,1-4.182,4.2,4.205,4.205,0,0,1-4.176-4.235,4.151,4.151,0,0,1,4.125-4.1,4.088,4.088,0,0,1,4.233,4.129",
    transform: "translate(-9.031 -101.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.692,54.251a4.157,4.157,0,0,1,.068,8.314,4.158,4.158,0,1,1-.068-8.314",
    transform: "translate(-9.049 -33.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.792,188.37a4.175,4.175,0,1,1-8.346-.233,4.175,4.175,0,0,1,8.346.233",
    transform: "translate(-67.685 -114.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.562,18.616a4.175,4.175,0,0,1-8.35.045,4.175,4.175,0,1,1,8.35-.045",
    transform: "translate(-33.837 -8.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.212,116.77a4.174,4.174,0,1,1,0-8.347,4.174,4.174,0,0,1,0,8.347",
    transform: "translate(0 -67.673)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.61,41.031a4.164,4.164,0,1,1,4.2-4.18,4.121,4.121,0,0,1-4.2,4.18",
    transform: "translate(-67.703 -20.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.621,0a4.112,4.112,0,0,1,4.173,4.192,4.167,4.167,0,1,1-8.332-.158A4.122,4.122,0,0,1,112.621,0",
    transform: "translate(-67.697 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.555,117.636a2.913,2.913,0,0,1-2.928-2.911,2.966,2.966,0,0,1,2.878-2.817,2.865,2.865,0,0,1,.05,5.728",
    transform: "translate(-44.082 -69.848)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.02,114.835a2.97,2.97,0,0,1-2.9,2.8,2.864,2.864,0,1,1,2.9-2.8",
    transform: "translate(-95.692 -69.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.617,138.467a3.008,3.008,0,0,1,2.974-2.721,2.861,2.861,0,1,1-.279,5.715,2.954,2.954,0,0,1-2.695-2.994",
    transform: "translate(-44.074 -84.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.2,88.09a2.926,2.926,0,0,1,2.82,3.013,3.013,3.013,0,0,1-2.989,2.7,2.86,2.86,0,0,1,.169-5.715",
    transform: "translate(-95.694 -54.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.167,135.727a2.865,2.865,0,0,1,.066,5.729,2.865,2.865,0,1,1-.066-5.729",
    transform: "translate(-95.696 -84.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.329,90.94a2.9,2.9,0,0,1-2.8,2.873,2.865,2.865,0,1,1-.02-5.729,2.884,2.884,0,0,1,2.818,2.856",
    transform: "translate(-44.081 -54.978)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.352,102.993a2.9,2.9,0,0,1-2.79,2.747,2.812,2.812,0,0,1-2.882-2.93,2.757,2.757,0,0,1,2.764-2.738,2.847,2.847,0,0,1,2.908,2.921",
    transform: "translate(-82.813 -62.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.455,153.375a2.833,2.833,0,0,1,.015-5.665,2.872,2.872,0,0,1,2.881,2.931,2.826,2.826,0,0,1-2.9,2.734",
    transform: "translate(-82.811 -92.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.148,100.084a2.8,2.8,0,0,1,2.876,2.791,2.764,2.764,0,0,1-2.771,2.876,2.834,2.834,0,1,1-.1-5.668",
    transform: "translate(-57.016 -62.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.8,111.91a2.862,2.862,0,1,1-2.845,2.838,2.948,2.948,0,0,1,2.845-2.838",
    transform: "translate(-69.879 -69.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.271,129.569a2.849,2.849,0,0,1-2.92-2.909,2.894,2.894,0,0,1,2.777-2.76,2.814,2.814,0,0,1,2.9,2.774,2.767,2.767,0,0,1-2.753,2.895",
    transform: "translate(-57.017 -77.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.353,126.782a2.861,2.861,0,0,1-2.758,2.774,2.811,2.811,0,0,1-2.914-2.9,2.766,2.766,0,0,1,2.73-2.773,2.872,2.872,0,0,1,2.942,2.9",
    transform: "translate(-82.813 -77.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.674,91.025a2.859,2.859,0,1,1-2.733-2.944,2.95,2.95,0,0,1,2.733,2.944",
    transform: "translate(-69.879 -54.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.819,165.28a2.863,2.863,0,1,1,2.853-2.827,2.942,2.942,0,0,1-2.853,2.827",
    transform: "translate(-69.877 -99.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.674,138.557a2.858,2.858,0,1,1-2.868-2.82,2.956,2.956,0,0,1,2.868,2.82",
    transform: "translate(-69.879 -84.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.674,67.192a2.859,2.859,0,1,1-2.752-2.928,2.948,2.948,0,0,1,2.752,2.928",
    transform: "translate(-69.878 -40.11)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.316,76.283a2.828,2.828,0,0,1-.164,5.654,2.873,2.873,0,0,1-2.806-3,2.824,2.824,0,0,1,2.97-2.652",
    transform: "translate(-57.012 -47.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.27,147.74a2.831,2.831,0,0,1,2.752,2.909A2.738,2.738,0,0,1,94.14,153.4a2.834,2.834,0,0,1-2.789-2.888,2.9,2.9,0,0,1,2.919-2.767",
    transform: "translate(-57.017 -92.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.441,81.917a2.832,2.832,0,0,1-2.759-2.9,2.737,2.737,0,0,1,2.876-2.754,2.832,2.832,0,0,1,2.8,2.882,2.9,2.9,0,0,1-2.912,2.774",
    transform: "translate(-82.813 -47.597)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLogo);
export default __webpack_public_path__ + "static/media/short-logo.6640a784bab5dd16340b704d18950d84.svg";
export { ForwardRef as ReactComponent };